module.exports = __webpack_public_path__ + "static/images/cover_C1.fc692a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C1.png
// module id = y1eE
// module chunks = 8